import React from "react";
import { useMatches } from "react-router";

import { IMatches } from "../types/shared";

const Breadcrumbs = (): React.JSX.Element => {
    let matches: IMatches[] = useMatches() as IMatches[];

    let crumbs = matches
        .filter(match => Boolean(match.handle?.crumb))
        .map(match => match.handle.crumb(match.data));

    const lastCrumb = React.Children.toArray(crumbs[crumbs.length - 1])[0];
    const lastCrumbText = React.isValidElement(lastCrumb)
        ? React.Children.toArray(lastCrumb.props.children).join("")
        : lastCrumb;

    return (
        <ol>
            {crumbs.map((crumb, index) => {
                return (
                    <li key={index}>
                        {index === crumbs.length - 1 ? lastCrumbText : crumb}
                    </li>
                );
            })}
        </ol>
    );
};

export default Breadcrumbs;
